import React from "react";
import {
  Card,
  Row,
  Button,
} from "react-bootstrap";
import "react-multiple-select-dropdown-lite/dist/index.css";
import { useDispatch } from 'react-redux';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MySelect } from "../ui/controls/MySelect";
import { getGroupFilesList } from "../../store/slices/groupFiles/thunks";
import { MyTextInput } from "../ui/controls/MyTextInput";
import { onlyIntegers } from "../../helpers/numericFields";

export const FormSearchFile = () => {
  const dispatch = useDispatch();
  const isOpenFilter = [
    { value: 1, label: "Abiertos" },
    { value: 0, label: "Cerrados" }
  ]

  return (
    <div>

      <Row>
        <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
          <Card>
            <Card.Header>
              <h4 className="card-title">Buscar Expedientes</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{
                  file: '',
                  isOpen: { value: 1, label: "Abiertos" }
                }}
                onSubmit={(({ file, isOpen },
                  { resetForm, setErrors }) => {

                  dispatch(getGroupFilesList(file, isOpen.value));

                })}
                validationSchema={
                  Yup.object({
                  })
                }
              >

                {
                  ({ setFieldValue }) => (
                    <Form>
                      <Row>
                        <div className="col-lg-4 col-md-12">
                          <div className=" row mb-4">
                            <MyTextInput label='Por #:' name='file' mode='horizontal'
                              onChange={(e) => {
                                if (!onlyIntegers(e)) {
                                  return
                                }
                                setFieldValue("file", e.target.value);
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className=" row mb-4">
                            <MySelect label='Estado:' name="isOpen" options={isOpenFilter} mode='horizontal'
                              singleSelect="true"
                              onChange={e => {
                                setFieldValue("isOpen", e);
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-12">
                          <div className=" row mb-4">
                            <Button variant="primary" type="submit">
                              Buscar
                            </Button>
                          </div>
                        </div>
                      </Row>
                    </Form>
                  )
                }
              </Formik>
            </Card.Body>
          </Card>
        </div>
      </Row>
    </div>
  );
}
